interface Distribution {
  top1: number
  top3: number
  top5: number
  top10: number
  top30: number
  notRanked: number
}

interface DistributionTableProps {
  distribution: Distribution
  totalKeywords: number
  previousDistribution?: Distribution | null
}

const columns = [
  { label: 'TOP 1', key: 'top1' as const, color: '#10B981', bg: 'rgba(16,185,129,0.08)' },
  { label: 'TOP 2-3', key: 'top3' as const, color: '#22C55E', bg: 'rgba(34,197,94,0.08)' },
  { label: 'TOP 4-5', key: 'top5' as const, color: '#3B82F6', bg: 'rgba(59,130,246,0.08)' },
  { label: 'TOP 6-10', key: 'top10' as const, color: '#6366F1', bg: 'rgba(99,102,241,0.08)' },
  { label: 'TOP 11-30', key: 'top30' as const, color: '#FBBF24', bg: 'rgba(251,191,36,0.08)' },
  { label: '> 100', key: 'notRanked' as const, color: '#94A3B8', bg: 'rgba(148,163,184,0.08)' },
]

export default function DistributionTable({ distribution, totalKeywords, previousDistribution }: DistributionTableProps) {
  if (totalKeywords === 0) return null

  return (
    <div className="bg-white border border-[#E2E4ED] rounded-xl p-5">
      <h3 className="text-sm font-semibold text-[#1B2559] mb-4">Repartition detaillee</h3>
      <div className="grid grid-cols-6 gap-2">
        {columns.map(col => {
          const count = distribution[col.key]
          const pct = totalKeywords > 0 ? Math.round((count / totalKeywords) * 100) : 0
          const prevCount = previousDistribution ? previousDistribution[col.key] : count
          const delta = count - prevCount

          return (
            <div
              key={col.key}
              className="rounded-xl p-3 text-center"
              style={{ backgroundColor: col.bg }}
            >
              <div
                className="text-[10px] font-bold uppercase tracking-wider mb-2"
                style={{ color: col.color }}
              >
                {col.label}
              </div>
              <div className="text-2xl font-bold text-[#1B2559] tabular-nums mb-0.5">
                {pct}%
              </div>
              <div className="text-xs text-[#555A73] tabular-nums mb-1">
                {count.toLocaleString('fr-FR')} mot{count !== 1 ? 's' : ''}-cle{count !== 1 ? 's' : ''}
              </div>
              {delta !== 0 && (
                <span
                  className={`inline-flex items-center text-[10px] font-semibold tabular-nums ${
                    delta > 0 ? 'text-emerald-600' : 'text-red-500'
                  }`}
                >
                  {delta > 0 ? '+' : ''}{delta}
                </span>
              )}
              {delta === 0 && (
                <span className="inline-flex items-center text-[10px] text-[#B0B4C5] tabular-nums">
                  -
                </span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
